import { id } from 'date-fns/locale';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import InputGroup from '../../core/InputGroup';
import InputGroupHorizontal from '../../core/InputGroupHorizontal';
import { useFormContextOrFallBack } from '../../core/Form/useFormContextOrFallBack';

export type SuppliersInputProps = {
  id: string;
  index: number;
  horizontal: boolean;
  required: boolean;
};

export const SuppliersInput = ({ horizontal, required = false, id, index }: SuppliersInputProps) => {
  const {
    formState: { errors }
  } = useFormContextOrFallBack();

  const formError = errors[id];

  const { watch, setValue } = useFormContext();
  const suppliers = watch('suppliers') || [];

  const handleSupplierChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedSuppliers = [...suppliers];
    updatedSuppliers[index] = event.target.value;

    setValue('suppliers', updatedSuppliers, { shouldValidate: true, shouldDirty: true });
  };

  const Group = horizontal ? InputGroupHorizontal : InputGroup;
  return (
    <Group id={id} required={required} label={`Fournisseur n°${index + 1}`} error={formError?.message as unknown as string | undefined} center>
      <input
        type="text"
        value={suppliers[index] || ''}
        onChange={handleSupplierChange}
        required={required}
        placeholder={`Fournisseur n°${index + 1}`}
        className="rounded-md p-2 border-gray-200 focus:ring-0 focus:outline-none "
      />
    </Group>
  );
};

export default SuppliersInput;
